import { render, staticRenderFns } from "./monthDialog2.vue?vue&type=template&id=066016c6"
import script from "./monthDialog2.vue?vue&type=script&lang=js"
export * from "./monthDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports